require('./RASuitabilityTestFailure.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText } = require('core/i18n').i18n;
// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
// @constants
const { MYPROFILE_BROKER_ROBO_URL } = require('../../../raConstants/index');
const {
    PrinterPreviewManager,
} = require('components/contactCenter/printer/printerPreviewManager');

class RASuitabilityTestFailure extends React.Component {
    buildPrinterPreviewManager() {
        const titleValue = 'roboPrintTitle-testResult';

        return <PrinterPreviewManager titleOverrider={titleValue} />;
    }
    render() {
        return (
            <section
                id="printable-wizard"
                className="ra-suitability-test-failure"
            >
                <div className="ra-suitability-test-failure__icon-container">
                    <i className="ra-suitability-test-failure__icon" />
                </div>
                <div className="ra-suitability-test-failure__title">
                    <FormattedText
                        className="ra-suitability-test-failure__title-text"
                        value="raSuitabiltyTestFailure-title"
                    />
                </div>
                <div className="ra-suitability-test-failure__disclaimer">
                    <FormattedText
                        className="ra-suitability-test-failure__disclaimer-text"
                        value="raSuitabiltyTestFailure-disclaimer"
                    />
                </div>
                <div className="ra-suitability-test-failure__disclaimer">
                    <FormattedText
                        className="ra-suitability-test-failure__disclaimer-email-notification no-print-out"
                        value="raSuitabiltyTestFailure-emailNotification"
                        injectedStrings={[this.props.email]}
                    />
                </div>
                <div className="ra-suitability-test-failure__print">
                    {this.buildPrinterPreviewManager()}
                </div>
                <div className="ra-suitability-test-failure__button">
                    <OKButton
                        modifier="secondary"
                        to={MYPROFILE_BROKER_ROBO_URL}
                    >
                        <FormattedText value="raSuitabiltyTestFailure-ctaButton" />
                    </OKButton>
                </div>
            </section>
        );
    }
}

RASuitabilityTestFailure.propTypes = {
    email: PropTypes.string.isRequired,
};

module.exports = RASuitabilityTestFailure;
